import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";

import { NsiTnvedDto, TradeItemDto } from "@app/user/marks/marks-store/marks-types";
import { TranslationService } from "@core/translation.service";
import { OverlayService } from "@core/overlay.service";
import { DocumentType } from "@helper/abstraction/documents";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-search-items-list",
  templateUrl: "./search-items-list.component.html",
  styleUrls: ["./search-items-list.component.scss"]
})
export class SearchItemsListComponent implements OnChanges {
	@Input() public data: TradeItemDto[] = [];
	@Input() public notFound = false;
	@Input() public gtinMode = false;
	@Input() public tabMode = false;
	@Input() public documentType?: DocumentType;
	@Input() public tNVEDCodes?: string[] = [];
	@Input() public tNVEDList?: NsiTnvedDto[] = [];
	@Output() public appSelect: EventEmitter<TradeItemDto> = new EventEmitter<TradeItemDto>();

  public selectRow?: TradeItemDto;
  // public customCodeSet: { id: number; name: string }[] = [];
  public editable = false;
  public isError = false;
  public customCode: string | { id: number, name: string } | null = null;
  public env = environment;

  constructor(
    private overlayService: OverlayService,
    private translationService: TranslationService,
  ) { }

  public ngOnChanges(): void {
    if (!this.data?.length) {
      this.selectRow = undefined;
      this.customCode = null;
      this.editable = false;
      this.isError = false;
    }
  }

  public onRowSelect(event: any): void {
    if (this.selectRow?.gtin === event.data.gtin) {
      return;
    }
    if (this.selectRow?.gtin && this.selectRow?.gtin !== event.data.gtin) {
      this.customCode = null;
      this.isError = false;
      this.editable = false;
    }
    this.selectRow = { ...event.data, isTraceable: this.handleCodes(event.data.tnvedCode, event.data.extraCustomsCode) } as TradeItemDto;
    if (this.findCustomCodes(this.selectRow.tnvedCode).length && this.findCustomCodes(this.selectRow.tnvedCode).includes(this.selectRow.extraCustomsCode)) {
      this.customCode = this.findCustomCodes(this.selectRow.tnvedCode).length === 1
                          ? this.selectRow.extraCustomsCode
                          : this.findCustomCodes(this.selectRow.tnvedCode).map((el: string, i: number) => { return { id: i, name: el  }}).find(item => item.name === this.selectRow?.extraCustomsCode);
    }
    if (this.findCustomCodes(this.selectRow.tnvedCode).length && !this.findCustomCodes(this.selectRow.tnvedCode).includes(this.selectRow.extraCustomsCode)) {
      this.customCode = this.selectRow.extraCustomsCode;
    }
    if (!this.findCustomCodes(this.selectRow.tnvedCode).length) {
      this.customCode = this.selectRow.extraCustomsCode;
    }
    this.editable = !!!this.selectRow?.extraCustomsCode;
  }

  public handleCodes(tnvedCode: string, customCode?: string): boolean {
    const findTnved = this.findCustomCodes(tnvedCode);
    const cCode = this.checkCustomCode();

    if (!findTnved?.length || findTnved.length && !findTnved.includes(this.checkCustomCode())) {
      return false;
    }
    if (findTnved.length && cCode) {
      return findTnved.includes(cCode);
    }
    return false;
  }

  public unblockEditable(): void {
    this.editable = !this.editable;
  }

  public selectCurrentRow(): void {
    if (this.checkCustomCodeLength()) {
      this.overlayService.showNotification$(this.translationService.getTranslation("customCodeSearchItemPopup"), "error", undefined, undefined, true);
      return;
    }
    let mapItem = {
      ...this.selectRow,
      extraCustomsCode: this.customCode,
      isTraceable: this.handleCodes(this.selectRow?.tnvedCode!, this.selectRow?.extraCustomsCode),
      isEditableValue: this.checkCustomCode() !== this.selectRow?.extraCustomsCode && this.selectRow?.customCodesSets?.some(el => el.name !== this.checkCustomCode())
    };
    if (this.documentType !== "EWAYBILL" && !mapItem.isTraceable) {
      this.isError = true;
      this.overlayService.showNotification$(this.translationService.getTranslation("customCodeSearchItemError"), "error", undefined, undefined, true);
      return;
    }
    this.isError = false;

    if (mapItem.isEditableValue) {
      // mapItem.customCodesSets?.splice(0, 0, { id: 0, name: mapItem?.extraCustomsCode as string });
      // const racalculateIdx = mapItem.customCodesSets?.map((el: { id: number, name: string }, i: number) => { return { ...el, id: i } });
      // mapItem.customCodesSets = racalculateIdx;
      mapItem.extraCustomsCode = { id: 0, name: mapItem?.extraCustomsCode as string };
    }
		this.appSelect.emit(mapItem as TradeItemDto);
  }

  public editInputComplete(event: any): void {
    this.customCode = event;
    this.checkCustomCodeLength();
  }

	public changeDropdownValue(event: any): void {
    this.customCode = event.value.name ?? event.value;
    this.isError = !!this.checkCustomCode()?.length;
    this.checkCustomCodeLength();
	}

  public findCustomCodes(tnvedCode: string): string[] {
    const findTnved = this.tNVEDList?.find(el => el.code === tnvedCode)?.customCodeSet;

    return findTnved || [];
  }

  // TEST
  // public find(tnvedCode: string): string {
  //   const findTnved = this.tNVEDList?.find(el => el.code === tnvedCode)?.customCodeSet?.join(" / ");

  //   return findTnved!;
  // }

  private checkCustomCodeLength(): boolean {
    if (!this.customCode) {
      return false;
    }
    const custCode = this.checkCustomCode()?.length;

    this.isError = ![0, 4].includes(custCode);
    return this.isError;
  }

  private checkCustomCode(): string {
    if (typeof this.customCode === "string") {
      return this.customCode;
    } else {
      return this.customCode?.name!
    }
  }
}
